import $ from 'jquery';
import 'slick-carousel';
import VideoHelper from '../../00_utilities/helpers/VideoHelper';
import GeneralHelper from '../../00_utilities/helpers/GeneralHelper';
import AccessibilityHelper from '../../00_utilities/helpers/AccessibilityHelper';

class Slider {
    constructor(elem) {
        this.elem = elem;
        this.breakpoints = {
            'screen-xs': 576,
            'screen-sm': 768,
            'screen-md': 992,
        };
        this.slidesNumber = this.elem.querySelectorAll('.slider__item').length;
        this.slidesToShow = parseInt(this.elem.getAttribute('data-slides-to-show'), 10) || 1;
    }

    init() {
        const hasOSReducedMotion = AccessibilityHelper.prefersReducedMotion();

        if (this.elem.classList.contains('slider--mobile')) {
            this.initMobileSlider();

            return;
        }
        if (this.elem.classList.contains('slider--continuous')) {
            this.initContinuousScroll(!hasOSReducedMotion);

            return;
        }

        const settings = this.assembleSliderSettings();

        $(this.elem).on('beforeChange', () => {
            VideoHelper.stopAll();
        });

        // init slider
        if (this.getNumberOfMinimumSlides() > this.slidesToShow) {
            $(this.elem).slick(settings);
        }
    }

    getNumberOfMinimumSlides() {
        const galleryElem = this.elem.closest('.gallery');
        return galleryElem ? Math.max(this.slidesNumber - 1, 1) : this.slidesNumber;
    }

    initializeSliderArrows() {
        const buttonNextText = this.elem.getAttribute('data-slider-button-next') || 'Next';
        const buttonPrevText = this.elem.getAttribute('data-slider-button-prev') || 'Previous';

        let prevArrow = `<button class="slick-prev slick-arrow" type="button">${buttonPrevText}</button>`;
        let nextArrow = `<button class="slick-next slick-arrow" type="button">${buttonNextText}</button>`;

        const dataArrowClass = this.elem.getAttribute('data-arrow-class');
        if (dataArrowClass) {
            const componentContainer = this.elem.closest('.component-container');
            const prev = componentContainer.querySelector(`.${dataArrowClass}-prev`);
            if (prev) {
                prevArrow = prev;
            }
            const next = componentContainer.querySelector(`.${dataArrowClass}-next`);
            if (next) {
                nextArrow = next;
            }
        }

        return { prevArrow, nextArrow };
    }

    assembleSliderSettings() {
        const { prevArrow, nextArrow } = this.initializeSliderArrows();

        const dataInfinite = this.elem.getAttribute('data-infinite');
        const infinite = (dataInfinite === '1' || dataInfinite === 'true');

        const dataCenterMode = this.elem.getAttribute('data-center-mode');
        const centerMode = (dataCenterMode === '1' || dataCenterMode === 'true');

        let initialSlide = 0;
        if (centerMode) {
            initialSlide = Math.floor(this.slidesNumber / 2);
        }

        return {
            accessibility: true,
            dots: false,
            mobileFirst: true,
            slidesToShow: this.slidesToShow,
            slidesToScroll: 1,
            infinite,
            initialSlide,
            variableWidth: centerMode,
            centerMode,
            prevArrow,
            nextArrow,
        };
    }

    initMobileSlider() {
        const settings = {
            accessibility: true,
            dots: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            prevArrow: false,
            nextArrow: false,
            responsive: [
                {
                    breakpoint: this.breakpoints['screen-xs'] - 1, // https://github.com/kenwheeler/slick/issues/2503
                    settings: {
                        slidesToShow: 2,
                    },
                },
                {
                    breakpoint: this.breakpoints['screen-sm'] - 1, // https://github.com/kenwheeler/slick/issues/2503
                    settings: 'unslick',
                },
            ],
        };
        $(this.elem).slick(settings);

        window.addEventListener('resize', GeneralHelper.throttle((e) => {
            if (!this.elem.classList.contains('slick-initialized')
                && $(e.currentTarget).width() < this.breakpoints['screen-sm']) {
                $(this.elem).slick(settings);
            }
        }, 200));
    }

    initContinuousScroll(autoplay = true) {
        const settings = {
            speed: 9000,
            autoplay,
            autoplaySpeed: 0,
            cssEase: 'linear',
            slidesToScroll: 1,
            variableWidth: true,
            infinite: true,
            prevArrow: false,
            nextArrow: false,
        };
        $(this.elem).slick(settings);
    }
}

export default Slider;
